import { LAYOUT_FRONTSPACES } from '@bedrock/fido-sdk';
import _get from 'lodash/get';

const getItemTitle = item => {
  const content = _get(item, 'itemContent');

  return _get(content, 'title') || _get(content, 'extraTitle') || _get(content, 'image.caption') || '';
};

export const getScreenSaverItemsData = data => {
  const entity = _get(data, 'entity.id');

  if (entity === LAYOUT_FRONTSPACES.screensaver) {
    const items = _get(data, 'blocks[0].content.items') || [];

    return items
      .filter(item => _get(item, 'itemContent.image.id'))
      .map(item => ({
        details: _get(item, 'itemContent.extraDetails') || '',
        title: getItemTitle(item),
        imageId: _get(item, 'itemContent.image.id'),
        logoId: _get(item, 'itemContent.logo.id'),
      }));
  }

  return [];
};

export const getNextIndex = (index, collection) => (index + 1) % collection.length;

export const checkLayoutsNotEqual = (a, b) => (a && b ? a.layoutId !== b.layoutId : !a && b);
